import { DownloadRounded } from "@mui/icons-material";
import { Box, Button, Dialog, DialogActions, DialogContent, InputLabel, Stack, Typography, TextField } from "@mui/material";
import axios from "axios";
import { GlobalState } from "context/GlobalContext";
import { paymentTermColumns } from "data/supplierPageData";
import FileSaver from "file-saver";
import { useState } from "react";
import {
	SupplierModalHeader,
	modalCancelBtnSx,
	modalContentSx,
	modalFormStack,
	modalSaveBtnSx,
	supplierModalPaperProps,
	supplierUi,
} from "../../../shared/supplierUi";

const VerifyFinancialDetailsModal = ({ pageData, submitFunction, modalOpen, setModalOpen }) => {
	const [modifiedData, setModifiedData] = useState(pageData);
	const { setSnackBar, snackBar, setSnackBarOpen, setLoadingOpen } = GlobalState();

	const handleModalClose = () => {
		setModifiedData(pageData);
		setModalOpen(false);
	};
	const handleFormSubmit = (e) => {
		e.preventDefault();
		if (typeof submitFunction === "function") submitFunction(modifiedData.transaction_no);
	};

	const handleSnackBarCommon = (severity, message) => {
		setSnackBarOpen(true);
		setSnackBar({
			...snackBar,
			message: message,
			severity: severity,
			anchorOrigin: { horizontal: "center", vertical: "top" },
		});
	};

	const handleDownloadClick = async () => {
		setLoadingOpen(true);
		try {
			await axios.get(`/api/supplier/download_account_details/${pageData?.id}`, { responseType: "blob" }).then((res) => {
				const url = URL.createObjectURL(res.data);
				FileSaver.saveAs(url, `${pageData?.company_name}_account_details.xlsx`);
				handleSnackBarCommon("success", "Successfully download the file");
			});
		} catch (error) {
			handleSnackBarCommon("error", "Failed to download file");
		}
		setLoadingOpen(false);
	};
	return (
		<Dialog
			fullWidth
			maxWidth="sm"
			open={modalOpen}
			onClose={handleModalClose}
			component="form"
			onSubmit={handleFormSubmit}
			PaperProps={supplierModalPaperProps}>
			{pageData && pageData[paymentTermColumns.payment_mode.key] === "" ? (
				<>
					<SupplierModalHeader title="Cannot verify" subtitle="Payment term is not assigned for this vendor" />
					<DialogContent sx={{ px: 3, py: 2 }}>
						<Typography variant="body2" color="text.secondary">
							Assign a payment term before approving financial details.
						</Typography>
					</DialogContent>
					<DialogActions sx={{ px: 3, py: 2, borderTop: `1px solid ${supplierUi.border}` }}>
						<Button variant="outlined" onClick={() => handleModalClose()} sx={modalCancelBtnSx}>
							Close
						</Button>
					</DialogActions>
				</>
			) : (
				<>
					<SupplierModalHeader title="Verify payment mode" subtitle="Confirm payment method and enter transaction reference" />
					<Box sx={{ ...modalContentSx, pt: 2.5, display: "flex", flexWrap: "wrap", columnGap: 2, rowGap: 2 }}>
						<Stack sx={modalFormStack} spacing={0.5}>
							<InputLabel>Payment Mode</InputLabel>
							<Typography sx={{ fontWeight: 600, fontSize: 15, color: supplierUi.textPrimary }}>
								{pageData && pageData[paymentTermColumns.payment_mode.key]}
							</Typography>
						</Stack>
						<Stack sx={{ width: { xs: "100%", md: "60%" } }} spacing={1}>
							<Box sx={{ display: "flex", justifyContent: "flex-end" }}>
								<Button
									startIcon={<DownloadRounded />}
									variant="contained"
									onClick={handleDownloadClick}
									sx={modalSaveBtnSx}>
									Account Details
								</Button>
							</Box>
							<InputLabel>Transaction Number</InputLabel>
							<TextField
								size="small"
								type="number"
								value={modifiedData?.transaction_no}
								onChange={(e) => setModifiedData({ ...modifiedData, transaction_no: e.target.value })}
								placeholder="Enter Transaction Number"
								required
							/>
						</Stack>
						<Box width="100%" mt={0.5}>
							<Typography variant="caption" sx={{ color: supplierUi.textSecondary, display: "block", fontWeight: 600 }}>
								Note
							</Typography>
							<Typography variant="caption" sx={{ color: supplierUi.textMuted, display: "block" }}>
								For Cheque enter Cheque No. For NEFT and RTGS enter UTR No.
							</Typography>
						</Box>
					</Box>
					<DialogActions sx={{ px: 3, py: 2, borderTop: `1px solid ${supplierUi.border}`, gap: 1 }}>
						<Button variant="outlined" onClick={() => handleModalClose()} sx={modalCancelBtnSx}>
							Cancel
						</Button>
						<Button variant="contained" type="submit" sx={modalSaveBtnSx}>
							Verify
						</Button>
					</DialogActions>
				</>
			)}
		</Dialog>
	);
};

export default VerifyFinancialDetailsModal;
